// Trust badge showing the payment methods supported at checkout (via Razorpay).
// Logos are inline SVG/styled marks so there are no external image dependencies.

function Card({ children, label }) {
  return (
    <div
      aria-label={label}
      className="h-9 px-2.5 bg-white border border-gray-200 rounded-md flex items-center justify-center shadow-sm"
    >
      {children}
    </div>
  );
}

function Visa() {
  return (
    <Card label="Visa">
      <span className="italic font-extrabold tracking-tight text-[15px]" style={{ color: '#1A1F71' }}>
        VISA
      </span>
    </Card>
  );
}

function Mastercard() {
  return (
    <Card label="Mastercard">
      <svg width="34" height="22" viewBox="0 0 34 22" aria-hidden="true">
        <circle cx="13" cy="11" r="8" fill="#EB001B" />
        <circle cx="21" cy="11" r="8" fill="#F79E1B" />
        <path d="M17 5a8 8 0 0 1 0 12 8 8 0 0 1 0-12z" fill="#FF5F00" />
      </svg>
    </Card>
  );
}

function RuPay() {
  return (
    <Card label="RuPay">
      <span className="font-extrabold italic text-[14px] tracking-tight">
        <span style={{ color: '#097DC6' }}>Ru</span>
        <span style={{ color: '#F47216' }}>Pay</span>
      </span>
    </Card>
  );
}

function Upi() {
  return (
    <Card label="UPI">
      <span className="font-extrabold italic text-[14px] tracking-tight">
        <span style={{ color: '#E97626' }}>U</span>
        <span style={{ color: '#0C8540' }}>P</span>
        <span style={{ color: '#E97626' }}>I</span>
      </span>
    </Card>
  );
}

function GPay() {
  return (
    <Card label="Google Pay">
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21.35 11.1H12v3.83h5.35c-.23 1.4-1.66 4.1-5.35 4.1-3.22 0-5.85-2.66-5.85-5.95S8.78 7.13 12 7.13c1.83 0 3.06.78 3.76 1.45l2.57-2.48C16.7 4.57 14.6 3.6 12 3.6 6.97 3.6 2.9 7.67 2.9 12.68S6.97 21.75 12 21.75c5.27 0 8.76-3.7 8.76-8.92 0-.6-.06-1.06-.16-1.73z" fill="#4285F4" />
      </svg>
      <span className="ml-1 font-semibold text-[13px] text-gray-600">Pay</span>
    </Card>
  );
}

function PhonePe() {
  return (
    <Card label="PhonePe">
      <span
        className="text-white font-bold text-[11px] w-5 h-5 rounded-full flex items-center justify-center"
        style={{ backgroundColor: '#5F259F' }}
      >
        ₹
      </span>
      <span className="ml-1 font-semibold text-[13px]" style={{ color: '#5F259F' }}>
        PhonePe
      </span>
    </Card>
  );
}

function NetBanking() {
  return (
    <Card label="Net Banking">
      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" fill="#0F6FBF">
        <path d="M12 2 2 7v2h20V7L12 2zM4 11v7H2v2h20v-2h-2v-7h-2v7h-3v-7h-2v7h-2v-7H9v7H6v-7H4z" />
      </svg>
      <span className="ml-1 font-semibold text-[12px] leading-none" style={{ color: '#0F6FBF' }}>
        NET<br />Banking
      </span>
    </Card>
  );
}

export default function PaymentMethods({ className = '' }) {
  return (
    <div className={`bg-gray-50 rounded-xl border border-gray-100 p-4 text-center ${className}`}>
      <p className="text-xs font-semibold text-gray-500 mb-3">🔒 100% Secure payment</p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Visa />
        <Mastercard />
        <RuPay />
        <Upi />
        <GPay />
        <PhonePe />
        <NetBanking />
      </div>
    </div>
  );
}
